'use client';

import { usePathname, useParams } from 'next/navigation';

export function useBlogPage() {
  const pathname = usePathname();
  const { slug } = useParams();

  const isBlogPage = pathname.startsWith('/blog/');
  const isBlogListPage = pathname === '/blog';
  const isSingleBlogPage = isBlogPage && !!slug;

  return {
    isBlogPage,
    isBlogListPage,
    isSingleBlogPage,
  };
}
